import React, { createContext, useState, useEffect } from "react";
const UserContext = createContext();
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [packageType, setPackageType] = useState("basic");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      setPackageType(parsedUser.clinic?.package || "basic");
    }
  }, []);

  useEffect(() => {
    if (user) {
      setPackageType(user.clinic?.package || "basic");
    }
  }, [user]);

  return (
    <UserContext.Provider value={{ user, setUser, packageType }}>
      {children}
    </UserContext.Provider>
  );
};
export default UserContext;
